import React, { useEffect, useState } from "react";
import { Container, Card, Row, Col , Modal} from "react-bootstrap";
import { Heart, ShoppingCart , PlusCircle} from "lucide-react";
import { Button, Carousel } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Gardening = ({ handleCartClick, handleLikeClick , cartItems, likedItems, removeFromLiked , user, setUser, setCartItems, setLikedItems}) => {
  const [products, setproducts] = useState([]);
   const [showCartModal, setShowCartModal] = useState(false);
    const [showLikedModal, setShowLikedModal] = useState(false);
    const [addedProducts, setAddedProducts] = useState([]);
   const navigate = useNavigate();
   

   const proceedToCartPage = () => {
    navigate('/cart');
  };
  
  const toggleLike = (productId) => {
    setLikedItems((prevLiked) => {
      if (prevLiked.includes(productId)) {
        return prevLiked.filter((_id) => _id !== productId);
      } else {
        return [...prevLiked, productId];
      }
    });
  };

  const handleAddToCart = (product) => {
    if (!cartItems.includes(product._id)) {
      const updatedProduct = {
        ...product,
        img: `/images1/${product.item_name}.jpg`, // add this
        rate: '₹' + product.rate

      };
      setAddedProducts((prev) => [...prev, product._id]);
      handleCartClick(updatedProduct); // pass updated product
    }
  };
  

  useEffect(() => {
    fetch("https://backend-matihaat.onrender.com/itemDescription?description=gardening", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! Status: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        setproducts(data);
       
      })
      .catch((error) => console.error("Error fetching seeds:", error));
  }, []);

  return (
    
    <Container fluid className="top-deals-container text-center py-5">
    <h2 className="section-title mb-4">Gardening</h2>
    <Row>
      {products.map((product) => (
        <Col key={product._id} xs={12} sm={6} md={3} className="mb-4">
          <Card className="product-card shadow-lg mx-auto">
            <div className="d-flex justify-content-end">
            <Heart
              size={24}
              color={likedItems.includes(product._id) ? "red" : "gray"} // Set color to red if liked, otherwise gray
              className="cursor-pointer"
              onClick={() => {
                toggleLike(product._id); // Toggle like locally
                handleLikeClick(product); // Handle click logic passed down from parent
              }}
            />
              {/* <Heart size={24} className="text-muted like-icon" onClick={() => handleLikeClick(product)} /> */}
            </div>
            
            <Card.Img variant="top" src={`/images1/${product.item_name}.jpg`} className="product-image" />

            <Card.Body>
              <p className="product-category">{product.category}</p>
              <Card.Title className="product-title">{product.item_name}</Card.Title>
                <p className="product-price fw-bold">{product.rate}</p>
                {(() => {
                    // const rate = parseFloat(product.rate.replace("INR ", "")) || 0;
                    // if (!rate) return null; 
                    // const randomPercentage = Math.floor(Math.random() * (50 - 20 + 1)) + 20; // Random % between 20 and 50
                    // const calculatedMRP = Math.round(rate * (1 + randomPercentage / 100));
                    // const discount = calculatedMRP - rate;

                    const randomPercentage  = Math.ceil(((product.Regular_price-product.rate)/product.Regular_price) * 100)
                    return (
                    <>
                        <p className="product-mrp text-muted">
                        <s>MRP: ₹{product.Regular_price}</s>
                        </p>
                        <p className="product-discount text-success">
                        <div className="discount-badge"> {randomPercentage}% OFF</div>
                        </p>
                    </>
                    );
                })()}
              {/* <p className="product-mrp text-muted">
                <s>MRP: {product.mrp}</s>
              </p> */}
              <p className="product-price fw-bold">{product.price}</p>

              <Button 
                className="add-to-cart" 
                onClick={() => handleAddToCart(product)} 
                disabled={cartItems.includes(product._id)} 
              >
                <ShoppingCart size={20} /> 
                {addedProducts.includes(product._id) ? "Added to Cart" : "Add to Cart"}
              </Button>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
     <footer className="text-center py-4 mt-5" style={{ backgroundColor: '#f8f9fa' }}>
          <Container>
            <Row className="justify-content-center align-items-center mb-3">
              <Col xs="auto" style={{color: "white"}}>
                <i className="bi bi-headset" style={{ fontSize: '2.5rem', color: '#a8cb41' }}></i>
              </Col>
              <Col xs="auto" className="text-start" style={{color: "white"}}>
                <p className="mb-1 fw-medium" style={{color: "white"}}>Got Questions? Call us 24/7!</p>
                <h5 className="fw-bold text-dark m-0">+91 9654870373</h5>
              </Col>
            </Row>
    
            <div className="mb-3" style={{color: "white"}}>
              <a href="https://www.facebook.com/people/Mati-Haat/61550736893804/" target="_blank" rel="noopener noreferrer" className="mx-2 text-dark fs-4">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="https://www.instagram.com/matihaat/" target="_blank" rel="noopener noreferrer" className="mx-2 text-dark fs-4" style={{color: "white"}}>
                <i className="bi bi-instagram"></i>
              </a>
              <a href="https://www.youtube.com/@FarmingwithMatihaat" target="_blank" rel="noopener noreferrer" className="mx-2 text-dark fs-4" style={{color: "white"}}>
                <i className="bi bi-youtube"></i>
              </a>
            </div>
    
            <p className="text-muted mb-0 small" style={{color: "white"}}>© {new Date().getFullYear()} Mati Haat. All rights reserved.</p>
          </Container>
        </footer>     
    </Container>
  );
};

export default Gardening;
